module.exports = require("./src/sprintf.js");


/*****************
 ** WEBPACK FOOTER
 ** sprintf (bower component)
 ** module id = 384
 ** module chunks = 1
 **/